<template>
    <div class="ui-scroll">
        <ui-overlay-load v-if="loading || reload"/>
        <select-facebook-user :value="datatable.data" :total="datatable.total" @next-handler="nextPageHandler()" />
    </div>
</template>

<script>
    import { uiOverlayLoad  } from '@/components/ui'
    import selectFacebookUser from '../select-facebook-user'
    import store from '@/store'
    import axios from 'axios'

	export default {
        components: { uiOverlayLoad, selectFacebookUser },

		props: {
            sortBy: {
                type: Object,
                default() {
                    return {
                        value: 'id',
                        dir: 'desc'
                    }
                }
            },
            tableClass: {
                type: String,
                default: 'ui-table-content'
            },
            paginationFixedBotton: {
                type: Boolean,
                default: false
            },
            msg: {
                type: String,
                required: false
            },
            searchEvent: {
                type: String,
                required: false,
                default: 'datatable-search'
            },
            service: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            notFoundIcon:{
                type: String,
                required: true
            },
            notFoundText:{
                stype: String,
                required: true
            },
		},

		data(){
			return {
                api: null,
                datatable: {
                    params: {
                        sortBy: { ...this.sortBy },
                        search: '',
                        page: 1,
                        perPage: '*',
                        filter: []
                    },
                    data: [],
                    total: 0
                },
                loading: true,
                reload: false,
                timeout: null,
                accountData: [],
                pesquisa: false,
                isRequesting: false
            }
        },

        created() {
            this.$root.$on(this.searchEvent, (e) => {
                this.datatable.params.search = e
                this.datatable.params.page = 1
                this.searchEventHandler()
            })
            this.$root.$on('datatable-reload-scroll-facebook', () => {
                this.datatable = {
                    params: {
                        sortBy: { ...this.sortBy },
                        search: '',
                        page: 1,
                        perPage: '*',
                        filter: []
                    },
                    data: [],
                    total: 0
                }
                this.getData()
            })
        },

        beforeDestroy() {
            this.$root.$off('datatable-reload-scroll-facebook')
        },

        mounted() {
            this.loadService().then(async response => {
                this.api = response.default.build()
                this.getData()
            })
        },

        computed: {
            loadService() {
                return () => import('@/services/axios/modules/'+ this.service + '.js')
            },
            totalPages: {
                get() {
                    let quotient = Math.floor(this.datatable.total / this.datatable.params.perPage)
                    let remainder = this.datatable.total % this.datatable.params.perPage
                    return remainder === 0 ? quotient : quotient + 1
                }
            }
        },
		methods: {
              getData() {
                if(this.isRequesting) return;
                this.isRequesting = true
                this.reload = !this.loading ? true : false
                let params = { ...this.datatable.params }
                 this.api.dataTable(params)
                    .then(response => {
                        this.datatable.data = [ ...response.data.data ]
                        this.datatable.total = response.data.recordsTotal
                        this.$root.$emit('total-accounts', this.datatable.total)
                        this.reload = false
                        this.loading = false
                    })
                    .catch(error => {
                        if (!axios.isCancel(error)) console.log(error)
                    })
                    .finally(() => {
                        this.isRequesting = false
                    })
            },
            searchEventHandler: async function () {
                if (store.getters.datatableCancel) await store.getters.datatableCancel()
                this.getData()
            },
            nextPageHandler() {
                let page = this.datatable.params.page + 1
                this.setPage(page)
            },
            previousPageHandler() {
                let page = this.datatable.params.page - 1
                this.setPage(page)
            },
            updateLineHandler(event) {
                this.$set(this.datatable.data, event.index, event.value)
            },
            setPage(page) {
                if (page > 0 && page <= this.totalPages) {
                    this.datatable.params.page = page

                } else if (page <= 0) {
                    this.datatable.params.page = 1

                } else {
                    this.datatable.params.page = this.totalPages
                }
                this.getData()
            }
        }
	}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>